<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <button v-show="this.query.page == 1" class="fl-button" type="button" v-on:click="refreshingChange()"><i v-bind:class=this.refreshing_icon></i></button>
          </div>
          <h1>NCIOMd (parkoló) log</h1>

          <div class="row">
            <div class="col-xs-12">
              <h2>Kereső</h2>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="type" label="Típus" name="type" :options="search.type.items" v-on:input="typeChange" value="enter"/>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="buildings" label="Parkoló" name="buildings" :options="search.buildings.items" v-on:input="buildingChange"/>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="time_limit" label="Időkorlát" name="time_limit" :options="search.time_limits.items" v-on:input="timeLimitChange" value="1_WEEK"/>
            </div>
            <div class="col-xs-6">
              <inputbox id="kerkif" label="Név / Kártyaszám / Vonalkód száma / Rendszám" v-bind:errors="errors" name="kerkif" v-model="query.kerkif"></inputbox>
            </div>
            <!--<div class="col-xs-3">
              <button class="button with-icon" style="margin-top: 24px" type="button" v-on:click="searchClick"><i class="fa fa-search"></i>Keresés</button>
            </div>-->
          </div>

          <div v-if="logs.length > 0" class="table-with-title">
            <h2>Log</h2>
            <table class="list">
              <thead>
                <tr>
                  <th>Idő</th>
                  <th>Név</th>
                  <th>Kártyaszám</th>
                  <th>Hely</th>
                  <th>Station ID</th>
                  <th>Gate ID</th>
                  <th>Típus</th>
                  <th>Esemény</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(log, i) in logs">
                  <td :style="tdStyle(log)">{{log.timestamp}}</td>
                  <td :style="tdStyle(log)">{{log.creator_name}}</td>
                  <td :style="tdStyle(log)">{{log.card_number ? log.card_rule_prefix + log.card_number : log.barcode_number}}</td>
                  <td :style="tdStyle(log)">{{log.gatename}}</td>
                  <td :style="tdStyle(log)">{{log.stationid}}</td>
                  <td :style="tdStyle(log)">{{log.gateid}}</td>
                  <td :style="tdStyle(log)">{{log.type}}</td>
                  <td :style="tdStyle(log)">{{log.message}}</td>
                  <td v-if="log.rf_id" :style="tdStyle(log)"><i v-on:click="cardSearch(log.element_id)" style="font-size: 18px; cursor: pointer;" class="small-button fas fa-search"></i></td>
                  <td v-else>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="logs.length == 0" class="normal-text">
            Nem található log vagy nincs jogosultsága a megtekintéshez.
          </div>
          <pagination v-if="logs.length > 0" showcombo="1" :limit="query.limit" :amount="query.amount" v-on:pageChanged="pageChanged" v-model="query.page"></pagination>
        </div>
      </div>
    </div>

    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
import Vue from 'vue';
import JSONFormatter from 'json-formatter-js';

export default {
  components: {
  },

  computed: {
    refreshing_icon: function() {
      return this.refreshing == 1 ? "fa fa-stop" : "fa fa-play";
    }
  },

  data: function() {
    return {
      refreshing: 0,
      query: {
        page: 1,
        limit: 100,
        amount: 0,
        kerkif: '',
        type: 'enter',
        building: '',
        time_limit: '1_WEEK',
      },
      search: {
        type: {
          items: [],
          selected: 'enter'
        },
        buildings: {
          items: [],
          selected: ''
        },
        time_limits: {
          items: [{
            label: '- nincs korlát -',
            value: ''
          },
          {
            label: 'utolsó 1 hét',
            value: '1_WEEK'
          },
          {
            label: 'utolsó 1 hónap',
            value: '1_MONTH'
          },{
            label: 'utolsó 3 hónap',
            value: '3_MONTH'
          }],
          selected: '1_WEEK'
        },
      },
      logs: []
    }
  },

  watch: {
    '$route': 'routerChange'
  },

  created: function() {
    this.routerChange();
  },

  mounted: function() {
    var _this = this;

    this.getTypes();
    this.getLogs();
    this.getBuildings();
    if(this.query.page == 1) {
      this.refreshing = 1;
      this.$root.interval = setInterval(function() { 
        _this.getLogs();
      }, 2000);
    }
  },

  methods: {
    routerChange: function() {
      var _this = this;

      if (Object.keys(this.$route.query).length != 0) {
        // Lementi az url paraméterben átadott keresési értékeket
        this.query = JSON.parse(JSON.stringify(this.$route.query));

        this.search.type.selected = this.query.type;

      } else {
        this.query = {
          limit: 100,
          page: 1,
          kerkif: '',
          type: 'enter',
          building: '',
          time_limit: '1 WEEK'
        };
      }

      this.getLogs();
    },

    refreshingChange: function() {
      var _this = this;
      if(this.refreshing == 1) {
        this.refreshing = 0;
        clearInterval(this.$root.interval);
      } else {
        this.refreshing = 1;
        this.$root.interval = setInterval(function() { 
          _this.getLogs();
        }, 2000);
      }
    },

    /*searchClick: function() {
      if (this.$root.interval != undefined)
        clearInterval(this.$root.interval);

      this.query.page = 1;

      this.$router.push({path: '/device_log', query: this.query});
    },*/

    typeChange: function(val) {
      this.query.page = 1;
      this.query.type = val;
    },

    buildingChange: function(val) {
      this.query.page = 1;
      this.query.building = val;
    },

    timeLimitChange: function(val) {
      this.query.page = 1;
      this.query.time_limit = val;
    },

    pageChanged: function(val) {
      var _this = this;
      if (this.$root.interval != undefined && val != 1) {
        this.refreshing = 0;
        clearInterval(this.$root.interval);
      }
      this.query.page = val;
      this.$router.push({path: '/device_log', query: this.query});
    },

    cardSearch: function(val) {
      this.$router.push({path: '/card/edit', query: {cardID: val}});
    },

    tdStyle: function(log) {
      return {
        'background-color': log.row_background_color,
        'color': log.row_text_color
      }
    },

    getTypes: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('device_logtypes/' + _this.$root.user.apikey, {
          success: function(response) {
            _this.search.type.items = response.types;
          }
        });
      });
    },

    getBuildings: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('log_buildings/' + _this.$root.user.apikey + '/P', {
          success: function(response) {
            _this.search.buildings.items = response.buildings;
          }
        });
      });
    },

    getLogs: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('device_logs/' + _this.$root.user.apikey, {
          method: 'post',
          data: _this.query,
          success: function(response) {
            _this.logs = response.logs;
            _this.query.amount = response.amount;
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// device_log.vue?5ad637ed